import sci35 from "./Sci35 2.png"
import sci68 from "./Sci68 2.png"
import sci4bio from "./Sci4Bio_new.png"
import sci4ess from "./Sci4ESS 2.png"
import stemsims from "./STEM Sims logo3.jpeg"
import eSci21 from "./eSci21 2.png"
import homeschool from "./homeschool logo2.jpeg"
import masteryLoop from "./mastery loop 3.png"
import styles from "./Products.module.scss"
import { Link } from "react-router-dom"


const Products = () => {
  return (
  <>
    <div className="mb-3 mt-0 bg-white fun-text">
        <div className="d-flex pt-2 pb-2 border-primary" style={{borderBottom: "3px solid", backgroundColor: "#ffff77"}}>
            <div className="d-flex col mx-2 justify-content-around align-items-xl-end align-items-center">
                <Link className="col mx-2" to="/product/Sci35">
                    <img className={`${styles.topImage}`} src={sci35} alt="Sci35"/>
                </Link>
                <Link className="col mx-2" to="/product/Sci68">
                    <img className={`${styles.topImage}`} src={sci68} alt="Sci68"/>
                </Link>
            </div>
            <div className="col-5 d-grid justify-content-center">
                <h1 className="row-auto align-self-end mt-0 mb-2 fw-bold">
                    Science Test Preparation
                </h1>
                <h2 className="row-auto">
                    GRADES 3 - 12
                </h2>
            </div>
            <div className="d-flex col mx-2 justify-content-around align-items-xl-end align-items-center">
                <Link className="col mx-2" to="/product/Sci4Bio">
                    <img className={`${styles.topImage}`} src={sci4bio} alt="Sci4Bio"/>
                </Link>
                <Link className="col mx-2" to="/product/Sci4ESS">
                    <img className={`${styles.topImage}`} src={sci4ess} alt="Sci4ESS"/>
                </Link>
            </div>
        </div>
        <div className="mx-2 mb-2 mt-1">
            <h2 className="fw-bold mx-2 mb-0">
                Standard Practice Tests Only Tell You What's Broken.
            </h2>
            <h2 className="fst-italic fw-bold">
                We Fix It!
            </h2>
            <p className="my-0 mx-2">
                Equip your students for State Science Assessments by closing the gap between assessment and mastery. Most prep platforms stop at reporting a low score—leaving teachers to diagnose and remediate on their own. Our Science Solutions turn diagnostic data into automatic, student self-directed, targeted intervention across four specialized product lines tailored to your curriculum.
            </p>
        </div>
        <div className="m-2">
            <img className={`${styles.threeStepsImage}`} src={masteryLoop} alt="Mastery Loop.png"/>
        </div>
        <h4 className="fw-bold mt-0 mx-2">
            Maximize Screen Time: Test Prep You Can't Do on Paper
        </h4>
        <div className="d-flex justify-content-around">
            <div className="col mb-2 mx-1">
                <h4 className="mt-2 mx-2 fw-bold">55% Normalized Gains</h4>
                <p className="m-2">
                    State-wide research shows significant, verifiable student progress between pre- and post-assessment metrics.
                </p>
            </div>
            <div className="col mb-2 mx-1">
                <h4 className="mt-2 mx-2 fw-bold">100% Standards Based</h4>
                <p className="m-2">
                    Every activity is structurally connected to specific DCIs, SEPs, and CCCs.
                </p>
            </div>
            <div className="col mb-2 mx-1">
                <h4 className="mt-2 mx-2 fw-bold">Trust & Compliance</h4>
                <p className="m-2">
                    All products strictly adhere to data privacy agreements (DPA), COPPA, and FERPA regulations. Student records are securely maintained and never shared.
                </p>
            </div>
        </div>
    </div>
    <h2 className="fun-text pt-1 mb-0 border-primary" style={{borderBottom: "3px solid", backgroundColor: "#ffff77"}}>Other Products</h2>
    <div className="d-flex mw-100 object-fit-contain justify-content-around fun-text m-1 mt-0 pt-0 p-1" style={{position:"sticky",bottom:"-270px"}}>
        <Link className="col m-1 rounded shadow bg-white p-4" to="/product/STEMSims">
            <img className={`m-2 ${styles.bottomImage}`} src={stemsims} alt="Stem Sims" />
        </Link>
        <Link className="col m-1 rounded shadow bg-white p-4" to="/product/eScience21" style={{textDecoration: "none", color: "black"}}>
            <img className={`m-2 ${styles.bottomImage}`} src={eSci21} alt="eScience21" />
            <p className="fw-light small m-2" style={{maxHeight:"200px", overflow:"hidden"}}>
                eScience 21TM is the digital edition of the grades 3-5 Science 21© curriculum. Science 21 is an integrated K-5 science curriculum developed locally and regionally at the Putnam/Northern Westchester BOCES. The science program is "Designed by Teachers for Teachers" and is aligned to the New York State Science Learning Standards. Science 21 helps students to engage in the sense-making of disciplinary science phenomena by using the Science and Engineering Practices and Crosscutting Concepts.
            </p>
            <h4>GRADES K - 5</h4>
        </Link>
        <Link className="col m-1 rounded shadow bg-white p-4" to="/homeschool">
            <img className={`m-2 ${styles.bottomImage}`} src={homeschool} alt="Homeschool" />
        </Link>
    </div>
  </>
  )
}

export default Products
